import { render, staticRenderFns } from "./pickLogistics.vue?vue&type=template&id=687d8cae&scoped=true&"
import script from "./pickLogistics.vue?vue&type=script&lang=js&"
export * from "./pickLogistics.vue?vue&type=script&lang=js&"
import style0 from "./pickLogistics.vue?vue&type=style&index=0&id=687d8cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d8cae",
  null
  
)

export default component.exports